//@ts-check
import React from 'react';
import { Grid, Button, Typography, LinearProgress } from '@material-ui/core';
import Utils from '../../utils';
import PageCommon from '../Common';
import PageNavBar from '../NavBar';
import { withTheme } from '@material-ui/core/styles';
import Loader from '../Settings/Installation/Loader';

var Center = function Center(_ref) {
  var children = _ref.children;
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      minHeight: 'calc(100vh - 160px)',
      textAlign: 'center',
      width: '100%'
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 6
  }, children));
};

var getLicenseMessage = function getLicenseMessage(licensing) {
  if (licensing.hasLicense) return 'You are licensed to use this application. Click below to manage your licenses or continue to use the app.';
  if (licensing.allowTrial) return 'No license found. Click below to install a license or start a 30 days trial.';
  if (licensing.trialExpired) return 'Your trial has expired. Click below to install a license or request an extension.';
  if (licensing.hasTrial) return "You are in trial mode and there are ".concat(licensing.remainingDays, " days left. Click below to install a license or continue with trial.");
  return 'No license found. Click below to install a license.';
};

var getManageLicensesUrl = function getManageLicensesUrl(appName, environment) {
  var host = Utils.getHost();
  if (host.endsWith('/')) host = host.substring(0, host.length - 1);
  return "".concat(host, "/Home/licensing?environment=").concat(encodeURIComponent(environment), "&returnUrl=").concat(encodeURIComponent(window.location.href));
};

var LicensingPage = function LicensingPage(_ref2) {
  var theme = _ref2.theme,
      appName = _ref2.appName,
      environment = _ref2.environment,
      licensing = _ref2.licensing,
      onStartTrial = _ref2.onStartTrial,
      onContinueTrial = _ref2.onContinueTrial;
  var bgColor = theme.common.Page.NavBar.style.backgroundColor;
  var initializing = licensing.initializing;
  var hasLicense = licensing.hasLicense,
      hasTrial = licensing.hasTrial;
  var allowTrial = licensing.allowTrial,
      error = licensing.error,
      startingTrial = licensing.startingTrial;
  if (initializing) return React.createElement(Loader, null);
  return React.createElement(React.Fragment, null, React.createElement(PageNavBar, null), React.createElement(PageCommon, {
    style: {
      color: theme.palette.getContrastText(bgColor),
      backgroundColor: bgColor
    }
  }, React.createElement(Center, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 4,
    alignItems: "center",
    justify: "center"
  }, error && React.createElement(Grid, null), React.createElement(Grid, {
    item: true
  }, !error && React.createElement(Typography, {
    color: "inherit"
  }, getLicenseMessage(licensing)), error && React.createElement(Typography, {
    color: "error"
  }, error)), React.createElement(Grid, {
    container: true,
    spacing: 4,
    alignItems: "center",
    justify: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "contained",
    disabled: startingTrial,
    onClick: function onClick() {
      return window.open(getManageLicensesUrl(appName, environment), '_self');
    }
  }, "Manage Licenses")), allowTrial && onStartTrial && React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: startingTrial,
    onClick: onStartTrial
  }, startingTrial && !error && 'Starting...', !startingTrial && (error ? 'Try Again' : 'Start Trial'))), hasLicense && React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: onContinueTrial
  }, "Continue")), hasTrial && React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: onContinueTrial
  }, "Continue Trial")))))));
};

LicensingPage.defaultProps = {
  trial: {},
  licensing: {},
  trialState: {},
  appName: '',
  environment: ''
};
export default withTheme(LicensingPage);